import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import { openNode } from '../../utility/TreeNavigation'
import { doUpdate, UpdateMethod } from '../../tree/nodeUpdates/utility'
import { UpdateLeafData } from '../../tree/nodeUpdates/types'
import { leafForId } from '../../utility/TreeHelpers'
import { ConfirmCommitButton } from 'shared/ui'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  allSwapUpdatesAtom,
  presentationsForGradeAtom,
  presentationSwapTreeAtom,
  presentationSwapTreeIdMapAtom,
} from './atoms'

export function UpdatesView() {
  return (
    <Box>
      <TotalCount />
      <Box padding="10px">
        <UpdatesHeader />
        <Completed />
        <NotFound />
        <Updates />
      </Box>
    </Box>
  )
}

function TotalCount() {
  const presentations = useAtomValue(presentationsForGradeAtom)
  if (presentations.state !== 'hasData' || !presentations.data) return null
  return (
    <Box>
      {presentations.data.length} Total Presentations in Google Drive For This
      Grade
    </Box>
  )
}

function UpdatesHeader() {
  const updatesData = useAtomValue(allSwapUpdatesAtom)
  if (!updatesData || !updatesData.updates.length) return null
  if (!updatesData.wrongIdCount) {
    return (
      <Box>
        All presentations are correct, the updates are for changing the url from
        things like `/edit` to `/preview`
      </Box>
    )
  }
  if (updatesData.wrongIdCount < updatesData.updates.length) {
    return (
      <Box>
        {updatesData.wrongIdCount} are pointing to the incorrect presentation,
        these must be fixed. The other updates are for correcting url
        destination to point to preview.
      </Box>
    )
  }
  return (
    <Box>
      {updatesData.wrongIdCount} presentations pointing to incorrect files.
    </Box>
  )
}

function Completed() {
  const updatesData = useAtomValue(allSwapUpdatesAtom)
  const idMap = useAtomValue(presentationSwapTreeIdMapAtom)

  const [expanded, setExpanded] = useState(false)

  if (!updatesData || !idMap) return null

  const { completed: list } = updatesData

  if (!list.length) return <Box>None Completed</Box>
  const go = (nodeId: string) => {
    const { node } = idMap[nodeId]
    openNode(node, idMap)
  }
  return (
    <Box>
      <Box>
        <Button
          onClick={() => setExpanded(!expanded)}
        >{`${list.length} Completed`}</Button>
      </Box>
      {expanded && (
        <Box padding="5px">
          {list.map((id) => (
            <Box key={id}>
              {idMap[id].node.leaves?.[0].body.file.name}
              <Button onClick={() => go(id)}>Go</Button>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}
function NotFound() {
  const updatesData = useAtomValue(allSwapUpdatesAtom)
  if (!updatesData) return null
  const { notFound: list } = updatesData
  if (!list.length) return null
  return (
    <Box>
      <Box>{`Not Found: ${list.length}`}</Box>
      <Box padding="5px">
        {list.map((id) => (
          <Box key={id}>{id}</Box>
        ))}
      </Box>
    </Box>
  )
}
function Updates() {
  const updatesData = useAtomValue(allSwapUpdatesAtom)
  const tree = useAtomValue(presentationSwapTreeAtom)
  const idMap = useAtomValue(presentationSwapTreeIdMapAtom)

  const [expanded, setExpanded] = useState(false)

  if (!updatesData || !tree || !idMap) return null

  const { updates: list } = updatesData
  const goTo = (data: UpdateLeafData) => {
    const leaf = leafForId(tree, data.ids.nodeId)!
    const { node } = idMap[leaf.parent_id!]
    openNode(node, idMap)
  }
  const UpdateItem = ({ data }: { data: UpdateLeafData }) => {
    const leaf = leafForId(tree, data.ids.nodeId)!
    const update = () => {
      doUpdate(data)
    }

    const bodyUrl =
      data.method === UpdateMethod.update &&
      'body' in data.params &&
      data.params.body?.url
    return (
      <Box>
        <Box>
          {`${leaf.body.file.name}: ${
            data.method === UpdateMethod.delete ? 'DEL' : 'UPD'
          }`}
          <Button onClick={() => goTo(data)}>Go</Button>
          <ConfirmCommitButton onClick={update}>Update</ConfirmCommitButton>
        </Box>
        <Box>
          <Box>{leaf.body.file.url}</Box>
          <Box>{bodyUrl}</Box>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      <Box>
        <Button
          onClick={() => setExpanded(!expanded)}
        >{`There are ${list.length} to update`}</Button>
      </Box>
      {expanded && (
        <Box>
          {list.map((data, index) => (
            <UpdateItem key={index} data={data}></UpdateItem>
          ))}
        </Box>
      )}
    </Box>
  )
}
